import { getThemeColor, legacyTheme } from 'styles/theme';

export const getChartColor = (color: string) =>
  getThemeColor(color, {
    snow: 'cream',
    white: '#f9f9f9',
  });
